import { render, staticRenderFns } from "./StoryboardsAspectRatioSelector.vue?vue&type=template&id=5d631006&scoped=true&"
import script from "./StoryboardsAspectRatioSelector.vue?vue&type=script&lang=js&"
export * from "./StoryboardsAspectRatioSelector.vue?vue&type=script&lang=js&"
import style0 from "./StoryboardsAspectRatioSelector.vue?vue&type=style&index=0&id=5d631006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d631006",
  null
  
)

export default component.exports